<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'BrasserieBlock',
  setup() {
    const textContainer = ref(null)

    onMounted(() => {
      gsap.fromTo(
          textContainer.value,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 1.5,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: textContainer.value,
              start: 'top 80%',
              toggleActions: 'play none none none',
            },
          }
      )
    })

    return {
      textContainer,
    }
  },
}
</script>

<template>
  <div class="w-full min-h-screen relative flex items-center justify-center">
    <img
        src="https://www.lemoniteur.fr/mediatheque/7/9/4/002268497.jpg"
        alt="Image brasserie déglingo"
        class="absolute inset-0 w-full h-full object-cover"
    />
    <div class="w-full h-full absolute bg-black opacity-50"></div>
    <div class="z-10" ref="textContainer">
      <h1 class="uppercase text-4xl lg:text-8xl z-10 text-white text-center font-sigmar tracking-wider font-extrabold mb-10">
        Visitez notre <br /> brasserie
      </h1>
      <h2 class="uppercase text-xl lg:text-2xl z-10 text-primary-700 text-center font-extrabold">
        L'expérience déglingo
      </h2>
      <p class="text-center w-full lg:w-1/3 mx-auto text-white mt-10">
        La riche histoire brassicole de la Brasserie Huyghe est conservée dans notre musée de la bière !
        Envie de découvrir l'origine de nos magnifiques bières ? Et d'être témoin de notre passion pour le brassage ?
        Réservez aujourd'hui encore votre visite de la brasserie et du musée, et repartez avec votre bouteille personnalisée.
      </p>
    </div>
  </div>
</template>
